export const UPDATED_EDITOR = 'updated_editor';
export const SET_EDITOR_REF = 'set_editor_ref';
